module.exports = __webpack_public_path__ + "img/step_6.19d5a0ef.svg";